module.exports = __webpack_public_path__ + "static/media/icon-aguardando.e895c691.svg";